class Pokemon {
	constructor(data) {
		this.name = data.name
		this.imageUrl = null
	}
}

export default Pokemon
